import React from "react";
import { BlurbBanner } from "./blurb_banner";

export function BlurbWrapper({ children }: { children: React.ReactNode }) {
	return (
		<div className="inline-flex flex-col">
			<BlurbBanner />
			<div className="w-screen">{children}</div>
		</div>
	);
}
